import React from "react";
import { Box, Typography, CardContent, Divider } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { FeeStructureStatsDto } from "../../../shared/dtos/feeStructure/FeeStructureStatsDto";
import { formatCurrency } from "../../../utils/currencyUtils";

interface FeeStructureOverviewWidgetProps {
  data: FeeStructureStatsDto;
}

const FeeStructureOverviewWidget: React.FC<FeeStructureOverviewWidgetProps> = ({
  data,
}) => {
  const meta = getEntityMeta("FEE_STRUCTURE");
  const Icon = meta.icon;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            my: 2,
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              {data.totalFeeStructureEntries}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Entries
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "success.main" }}
            >
              {formatCurrency(data.totalExpectedRevenue)}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Expected Revenue
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 0.5 }}>
            Highest Single Fee
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "info.main" }}
          >
            {formatCurrency(data.highestSingleFee)}
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default FeeStructureOverviewWidget;
